// extracted by mini-css-extract-plugin
export default {"see_more":"see_more__e272de66","light":"light__e272de66","dark":"dark__e272de66"};